<script setup>
import CreateEditUserBox from "./CreateEditUserBox.vue";
</script>

<template>
  <div class="adduser-overlay" @click.self="$emit('close-modal')">
    <div class="adduser-modal" role="dialog" aria-modal="true" aria-label="Add individual user">
      <div class="adduser-head" :style="{ backgroundColor: brandData?.main_color1 || '#0e5071' }">
        <span class="adduser-title">Add individual user</span>
        <button type="button" class="adduser-close" aria-label="Close" @click="$emit('close-modal')">&times;</button>
      </div>
      <div class="adduser-body">
        <CreateEditUserBox buttonLabel="Add" :userData="userData" :brandData="brandData" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminDashboardAddUserModal",
  props: ["userData", "brandData"],
  emits: ["close-modal"],
};
</script>

<style scoped>
.adduser-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.55); display: flex; align-items: center; justify-content: center; z-index: 2000; padding: 16px; }
.adduser-modal { background: #fff; width: 100%; max-width: 640px; max-height: 90vh; display: flex; flex-direction: column; border-radius: 6px; overflow: hidden; box-shadow: 0 8px 24px rgba(0,0,0,.3); }
.adduser-head { display: flex; align-items: center; justify-content: space-between; padding: 12px 20px; color: #fff; flex-shrink: 0; }
.adduser-title { font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: .03em; }
.adduser-close { background: none; border: none; color: #fff; font-size: 24px; line-height: 1; cursor: pointer; }
.adduser-body { padding: 8px 20px 20px; overflow-y: auto; }
/* The box was designed as a full page; remove its card styling inside the popup */
.adduser-body :deep(.box) { margin: 0; padding: 0; box-shadow: none; border-radius: 0; }
</style>